import { z } from 'zod';
export const phoneSchema = z
    .string()
    .regex(/^\+[1-9]\d{6,14}$/, 'Phone must be E.164 format (e.g. +16095053297)');
export const tickerSchema = z
    .string()
    .regex(/^[A-Z][A-Z0-9.]{0,7}$/, 'Ticker must be 1-8 chars, uppercase, may include digits or "."');
export const sideSchema = z.enum(['BUY', 'SELL']);
export const reasonSchema = z
    .string()
    .min(10, 'Reason must be at least 10 characters — write a real thesis')
    .max(2000);
export const requestOtpSchema = z.object({ phone: phoneSchema });
export const verifyOtpSchema = z.object({
    phone: phoneSchema,
    code: z.string().regex(/^\d{6}$/, 'OTP must be 6 digits'),
});
export const sellCircumstancesSchema = z.preprocess((v) => (typeof v === 'string' && v.trim() === '' ? undefined : v), z.string().min(10, 'Sell circumstances must be at least 10 characters').max(2000));
export const sellChecklistSchema = z.preprocess((v) => (Array.isArray(v) && v.length === 0 ? undefined : v), z
    .array(z.string().min(5, 'Question is too short').max(300, 'Question is too long'))
    .min(1, 'At least one yes/no checklist question required')
    .max(20, 'Too many checklist questions'));
export const buyMoreCircumstancesSchema = z.preprocess((v) => (typeof v === 'string' && v.trim() === '' ? undefined : v), z.string().min(10, 'Buy-more circumstances must be at least 10 characters').max(2000));
export const buyMoreChecklistSchema = z.preprocess((v) => (Array.isArray(v) && v.length === 0 ? undefined : v), z
    .array(z.string().min(5, 'Question is too short').max(300, 'Question is too long'))
    .min(1, 'At least one yes/no checklist question required')
    .max(20, 'Too many checklist questions'));
export const createTicketSchema = z
    .object({
    ticker: tickerSchema,
    side: sideSchema,
    shares: z.number().int().positive().max(10_000_000),
    reason: reasonSchema,
    sellCircumstances: sellCircumstancesSchema.optional(),
    sellChecklist: sellChecklistSchema.optional(),
    buyMoreCircumstances: buyMoreCircumstancesSchema.optional(),
    buyMoreChecklist: buyMoreChecklistSchema.optional(),
})
    .superRefine((val, ctx) => {
    if (val.side === 'BUY') {
        if (!val.sellCircumstances) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['sellCircumstances'],
                message: 'Required for BUY tickets — describe when you would exit',
            });
        }
        if (!val.sellChecklist || val.sellChecklist.length === 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['sellChecklist'],
                message: 'Required for BUY tickets — at least one yes/no question',
            });
        }
        if (!val.buyMoreCircumstances) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['buyMoreCircumstances'],
                message: 'Required for BUY tickets — describe when you would scale up',
            });
        }
        if (!val.buyMoreChecklist || val.buyMoreChecklist.length === 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['buyMoreChecklist'],
                message: 'Required for BUY tickets — at least one yes/no question',
            });
        }
    }
});
export const ticketStatusSchema = z.enum([
    'DRAFT',
    'NEEDS_REVIEW',
    'READY_FOR_SUBMISSION',
    'SUBMITTED',
    'FILLED',
    'CANCELLED',
]);
export const updateTicketSchema = z.object({
    status: ticketStatusSchema.optional(),
});
export const createFeedPostSchema = z.object({
    body: z
        .string()
        .min(1, 'Post cannot be empty')
        .max(2000, 'Post is too long')
        .transform((s) => s.trim())
        .refine((s) => s.length > 0, 'Post cannot be empty'),
});
export const castVoteSchema = z.object({
    value: z.enum(['UP', 'DOWN']),
    reason: z
        .string()
        .min(20, 'Reason must be at least 20 characters')
        .max(2000, 'Reason is too long'),
});
export const validateYesNoQuestionSchema = z.object({
    question: z.string().min(1).max(500),
});
export const adminUserActionSchema = z.object({
    reason: z.string().max(500).optional(),
});
//# sourceMappingURL=schemas.js.map